/* eslint-disable max-len */
import React from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { modalStorageKeys } from "../../../config/params";
import { formatPetNames } from "../../../components/AvailableTimeSlots/ExpressAvailableTimeSlots";
import { markPetsShownForModal } from "../../../services/wellness-plans-by-user/wellness-plan-by-user.service";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useCombinedAlertsDataStore } from "../../../hooks";
import WellnessRenewalPetAvatars from "../../../components/PetAvatars/WellnessRenewalPetAvatars";


const WellnessPlanRenewalSuccessfulAlert = () => {
  const { closeModal } = useModal();
  const { recentRenewedWPData } = useCombinedAlertsDataStore();

  const handleModalClose = (closeFromParent?: "closeIcon" | "gotIt") =>{
    if (recentRenewedWPData.length) {
      markPetsShownForModal(modalStorageKeys.autoRenewSuccessPlans, recentRenewedWPData.map((petData)=>petData.petId));
    }
    if (closeFromParent === "closeIcon") {
      recentRenewedWPData.forEach((petData) => {
        userActivityLogger(MIXPANEL_EVENTS.RENEWAL_SUCCESSFUL_POP_UP_DISMISSED, {
          pet_name: petData.petName,
          plan_name: petData.wellnessPlanName,
        });
      });
    } else if (closeFromParent === "gotIt") {
      recentRenewedWPData.forEach((petData) => {
        userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_GOT_IT_IN_POPUP, {
          popup_type: "plan_renewed",
          auto_renewal_flag: "yes",
          plan_name: petData.wellnessPlanName,
          pet_name: petData.petName,
        });
      });
    }
    closeModal();
  };


  return (
    <>

      {recentRenewedWPData.length > 0 &&
      <div className="flex flex-col justify-between w-full h-full xl:w-[25rem]">
        <div className="flex justify-end">
          <CloseIcon
            onClick={()=>handleModalClose("closeIcon")}
            className="text-light-black cursor-pointer"
          />
        </div>
        <div className="w-full flex flex-col justify-between items-center">
          {recentRenewedWPData.length &&
            <div>
              <WellnessRenewalPetAvatars petDetails={recentRenewedWPData} defaultWellnessStatus={true} />
            </div>
          }
          <div className="text-xl font-semibold flex justify-center xl:w-80 text-center my-1">
            {`${formatPetNames(recentRenewedWPData.map((petData)=>petData.petName ))} GoodPet+ Plan has renewed!`}
          </div>
        </div>

        <div className="w-full text-center bg-taupe-15 py-1 rounded-md my-1">
                    We&apos;ve sent you a reminder email
        </div>

        <div className="text-center pt-3 pb-4">
          {`You’ve unlocked another year of wellness plan benefits that makes ${formatPetNames(recentRenewedWPData.map((petData)=>petData.petName ))}
          care easier and more affordable. `}
        </div>

        <div className="pt-2 w-full">
          <StyledBookingFlowButton
            disabled={false}
            fullWidth
            color="primary"
            className={"!w-full !font-semibold !border-1 !border-gray-4 hover:!text-white hover:!bg-black !h-[2.5rem] !text-sm" }
            size="small"
            onClick={()=>handleModalClose("gotIt")}
          >
            {"Got It"}
          </StyledBookingFlowButton>
        </div>
      </div>}
    </>
  );
};

export default WellnessPlanRenewalSuccessfulAlert;
